//
//
//

import painter5 from '../../components/painter5.vue';
export default {
	components: { painter5 },
}
